import React from 'react'

const SignOfPendingBox = ({setVerify}) => {
    return (

        <div className='flex items-center flex-col z-10 justify-center px-2  w-full py-3 absolute top-0 '>
            <div className="bg-[#ffebee] border-t-4 border-red-500 rounded-b text-black px-4 py-3 shadow-md" role="alert">
                <div className="flex">
                    <div className="py-1"><svg className="fill-current h-6 w-6 text-red-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg></div>
                    <div>
                        <p className="font-bold">Broker sign-off Pending </p>
                        <p className="text-sm">You will receive an email once your broker has signed all documents. <span className='font-semibold'>If you no longer see this message, you are free to use Deli with your MLS data <br /> integrated.</span> </p>
                    </div>
                </div>
            </div>
{/*             
                <button onClick={()=>setVerify(true)} className='bg-green-500 text-white py-2 px-10 cursor-pointer mt-3 rounded-md'>
                    verify
                </button> */}
            
        </div>
    )
}

export default SignOfPendingBox